/**
 * Check if a given object implements the PermitManagementInfo interface.
 */
export function instanceOfPermitManagementInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function PermitManagementInfoFromJSON(json) {
    return PermitManagementInfoFromJSONTyped(json, false);
}
export function PermitManagementInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
    };
}
export function PermitManagementInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
    };
}
